import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Chip as MuiChip,
  Divider as MuiDivider,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { api } from "../../../../contexts/JWTContext";
import { alpha } from "@material-ui/core/styles";
import { makeStyles } from "@mui/styles";
import Loader from "../../../../components/Loaders/Loader";
import styled from "styled-components/macro";
import { spacing } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import useMediaQuery from "@mui/material/useMediaQuery";
import Editors from "../../../../components/CustomComponents/Editor/Editors";
import BusinessIcon from "@mui/icons-material/Business";
import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import Status from "../../../../components/status/Status";
const Divider = styled(MuiDivider)(spacing);

const useStyles = makeStyles((theme) => ({
  search: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    border: "1px solid black",
    padding: "3px",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),

    marginRight: theme.spacing(0),
    marginLeft: 0,
    width: "300px",
    [theme.breakpoints.up("sm")]: {
      width: "300px",
    },
  },
  searchIcon: {
    height: "100%",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
  },
  closeIcon: {
    height: "100%",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "96%",
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
    backArrow: {
      height: "40px",
      fontSize: "20px",
      marginLeft: "5px",
      color: "blue",
      textDecoration: "none",
      border: "2px solid red",
    },
    textField: {
      height: "10px",
      backgroundColor: "red",
      border: "2px  solid red",
      marginLeft: "10px",
    },
  },
}));
const CustomWidthTooltipOfDelete = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "red",
  },
});

const Chip = styled(MuiChip)`
  height: 20px;
  padding: 4px 0;
  font-size: 85%;
  background-color: ${(props) =>
    props.theme.palette[props.color ? props.color : "primary"].light};
  color: ${(props) => props.theme.palette.common.white};
  margin-bottom: ${(props) => props.theme.spacing(4)};
`;

const commentSection = {
  borderRadius: 10,
  backgroundColor: "#fafafa",
  marginTop: "2rem",
  padding: "1rem",
};

const DetailTask = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const params = useParams();
  const { id } = params;
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(null);
  const [getSelectedTask, setGetSelectedTask] = useState(null);
  const [commentsDetails, setCommentsDetails] = useState([]);
  const [addComment, setAddComment] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    getSelectedTasks();
    commentsDetails();
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  const handleClose = () => {
    setOpen(null);
  };

  const getSelectedTasks = async () => {
    try {
      setIsLoading(true);
      const res = await api.get(`/tasks/${id}`);
      if (res.status === 200) {
        setGetSelectedTask(res.data.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  //
  const getAllComments = async () => {
    try {
      setButtonLoader(true);
      const res = await api.get(`/comments/task/${id}`);
      if (res.status === 200) {
        setCommentsDetails(res?.data?.data?.results);
        setButtonLoader(false);
      }
    } catch (error) {
      setButtonLoader(false);
    }
  };

  const deleteComment = async (commentId) => {
    try {
      const res = await api.delete(`/comments/${commentId}`);
      if (res.status === 200) {
        getAllComments();

        // setCommentDelete(res.data.data);
        // setDeleteComment(res.data.data);
        setOpen(null);
      }
    } catch (error) {}
  };

  const postComment = async () => {
    try {
      setButtonLoader(true);

      const res = await api.post("/comments", {
        text: addComment,
        taskId: id,
      });
      if (res.status === 201) {
        // setCommentsDetails(res?.data?.data);
        getAllComments();
        // getSelectedTasks();
        setAddComment("");

        setButtonLoader(false);
      }
    } catch (error) {
      setButtonLoader(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Grid sx={{ display: "flex", alignContent: "center" }}>
            <ArrowBackIcon
              sx={{ color: "blue", cursor: "pointer", mr: "1rem" }}
              onClick={() => {
                navigate(-1);
              }}
            />
            <Typography
              variant="subtitle1"
              sx={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                navigate(-1);
              }}
            >
              {t("Details")}
            </Typography>
          </Grid>

          <Divider spacing={5} />

          <Card>
            <CardContent>
              <Grid
                container
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography gutterBottom variant="h3" component="h2">
                  {getSelectedTask?.title}
                </Typography>
                <Status task={getSelectedTask} />
                {/* <Chip sx={{ ml: "15px" }} label="In progress" color="warning" /> */}
              </Grid>

              <Typography
                mb={4}
                color="textSecondary"
                component="p"
                dangerouslySetInnerHTML={{
                  __html: getSelectedTask?.description,
                }}
              >
                {/* {getSelectedTask?.description} */}
              </Typography>

              <Grid
                spacing={8}
                sx={{ display: "flex", alignContent: "center" }}
              >
                <BusinessIcon sx={{ mr: "10px" }} />
                <Typography mb={2} color="textSecondary" component="p">
                  {getSelectedTask?.company?.name}
                </Typography>
              </Grid>
              <Grid
                spacing={8}
                sx={{ display: "flex", alignContent: "center" }}
              >
                <LocationOnIcon sx={{ mr: "10px" }} />
                <Typography mb={2} color="textSecondary" component="p">
                  {getSelectedTask?.location?.name}
                </Typography>
              </Grid>

              <Editors
                value={addComment}
                onChange={(e) => {
                  setAddComment(e?.target?.value);
                }}
              />
              {/* <ThemeButton
                name={t("Add_comment")}
                onClick={postComment}
                variant="contained"
                color="secondary"
                size="large"
                loading={buttonLoader}
              /> */}
              <LoadingButton
                sx={{ height: 50 }}
                onClick={() => {
                  postComment();
                }}
                variant="contained"
                loading={buttonLoader}
                style={{
                  borderColor: "#3c98eb",
                  color: "primary",
                  fontWeight: "600",
                  borderRadius: "0.3rem",
                  fontSize: "1rem",
                  lineHeight: 1.5,
                  padding: "0.5rem 1rem",
                }}
              >
                {t("Add_comment")}
              </LoadingButton>
            </CardContent>
          </Card>
        </>
      )}
      <>
        <CardContent>
          {commentsDetails &&
            commentsDetails?.map((comment) => {
              return (
                <>
                  {open === comment?.id && (
                    <Dialog
                      fullScreen={fullScreen}
                      open={open !== null ? true : false}
                      onClose={handleClose}
                      aria-labelledby="responsive-dialog-title"
                    >
                      <DialogTitle id="responsive-dialog-title">
                        {"Are you sure to delete Comment?"}
                      </DialogTitle>

                      <DialogActions>
                        <Button autoFocus onClick={handleClose}>
                          Disagree
                        </Button>
                        {/* onClick={setDeleteComment} */}
                        <Button
                          onClick={() => deleteComment(comment?.id)}
                          autoFocus
                        >
                          Agree
                        </Button>
                      </DialogActions>
                    </Dialog>
                  )}
                  <Grid sx={commentSection} style={{ minWidth: "200px" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography variant="h5" sx={{ marginTop: "10px" }}>
                          {comment.user.firstName}
                        </Typography>
                        <Typography
                          color="textSecondary"
                          sx={{ marginTop: "5px" }}
                          dangerouslySetInnerHTML={{
                            __html: comment.text,
                          }}
                        ></Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography>
                          {moment(comment?.createdAt).fromNow()}
                        </Typography>
                        <CustomWidthTooltipOfDelete title="Delete Comment">
                          <IconButton
                            aria-label="delete"
                            size="large"
                            // setDeleteId(row.id)
                            //setDeleteComment(id)
                            onClick={(e) => {
                              setOpen(comment?.id);
                              // deleteComment(id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </CustomWidthTooltipOfDelete>
                      </Box>
                    </Box>
                  </Grid>
                </>
              );
            })}
        </CardContent>
      </>
    </>
  );
};

export default DetailTask;
